<template>
 <b-form-group>
  <b-card>
    <b-form-row v-for="(additional_cost, additional_cost_index) in this.response.additional_costs" :key="additional_cost_index">
      
      <b-col lg="4" md="4" sm="12">
        <b-form-group v-bind:id="'amount-' + additional_cost_index" 
        :label="additional_cost_index == 0 ? 'Cost:' : ''" 
        v-bind:label-for="'input-amount-' + additional_cost_index + id">
          <b-input-group prepend="$"  size="sm">
            <b-form-input
             size="sm"
              v-bind:id="'input-amount-' + additional_cost_index + id"
              v-model="additional_cost.amount"
              type="number"
              min="0"
              placeholder="(free)"
              :number="true"
              
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col lg="4" md="4" sm="12">
        <b-form-group v-bind:id="'additional_cost_label-' + additional_cost_index" 
        :label="additional_cost_index == 0 ? 'Type:' : ''" 
        v-bind:label-for="'input-additional_cost_label-' + additional_cost_index + id">
          <b-form-input
           size="sm"
            v-bind:id="'input-additional_cost_label-' + additional_cost_index + id"
            v-model="additional_cost.label"
            placeholder="Enter Type"
            v-bind:list="'input-list-additional_cost_label-' + additional_cost_index + id"
            :state="additional_cost.label ? null : false"
          ></b-form-input>

          <b-form-datalist 
           size="sm"
            v-bind:id="'input-list-additional_cost_label-' + additional_cost_index + id"
            :options="additional_costs"
          ></b-form-datalist>
        </b-form-group>
      </b-col>  

      <b-col lg="3" md="4" sm="12">
        <b-form-group v-bind:id="'additional_cost_per_unit-' + additional_cost_index" 
        :label="additional_cost_index == 0 ? 'Per:' : ''" 
        v-bind:label-for="'input-additional_cost_per_unit-' + additional_cost_index + id">
          <b-form-select 
           size="sm"
            :inputId="'input-additional_cost_per_unit-' + additional_cost_index + id"
            v-model="additional_cost.per_unit"
            :options="additional_cost_pers"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col lg="1" md="6" sm="12">
         <b-form-group 
         :label="additional_cost_index == 0 ? 'Remove:' : ''" 
         >
              <b-button block variant="danger" size="sm" v-on:click="$emit('removeAdditionalCost', additional_cost_index)"
              v-b-tooltip.hover.bottom.v-secondary title="Remove this additional cost"
              ><i class="fa fa-trash"></i></b-button>
         </b-form-group>
      </b-col>

    </b-form-row>


    <b-container fluid>
      <b-form-row>
        <b-col cols="1">
          <b-button block variant="info" 
          size="sm" 
          v-on:click="$emit('addAdditionalCost')"><i class="fa fa-plus" /></b-button>
        </b-col>
        <b-col cols="11" align-self="center">
         {{this.caption}}
        </b-col>
      </b-form-row>
    </b-container>
  </b-card>
</b-form-group>
</template>

<script>
export default {
  name: "rfqs-additional-cost",
  props: [
    'response',
    'additional_costs',
    'id',
    'caption'
  ],
  data() {
    return {
      additional_cost_pers: [
        { value: true, text: "Line" },
        { value: false, text: "Order" }
      ]
    };
  },
  mounted() {
    //console.log("FormAdditionalCost.response.additional_costs...");
    //console.log(this.response.additional_costs); 

  }
};
</script>

<style scoped>

.form-group {
  margin-bottom: 0.75rem;
}
</style>